var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tabs",
    [
      _c("tab", { attrs: { title: "Recent Users" } }, [_c("UsersList")], 1),
      _vm._v(" "),
      _vm.hasScramblePermission
        ? _c(
            "tab",
            { attrs: { title: "Expired Users" } },
            [
              _c("ExpiredInactiveUsersExport"),
              _vm._v(" "),
              _c("h1", { staticClass: "light" }, [_vm._v("Data Privacy")]),
              _vm._v(" "),
              _c("UserScramblePage")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }